import {getEncryptBody, getHeader} from '../util/makePostData'
import {post} from './http'

// 普通接口
export function handleSend (data, appCode, bizCode, operaType = '0', showType = 'Alert', isDesensit = 'true') {
  // 加密处理
  let encryptResult = getEncryptBody(appCode, bizCode, data, operaType, isDesensit)
  let encryptMsg = encryptResult.body
  let config = {
    headers: encryptResult.headers
  }
  let interfaceCode = encryptResult.interfaceCode
  return post('/handle', appCode, bizCode, encryptMsg, showType, config, true, interfaceCode)
}

// 上传文件接口
export function handleFileSend (url = '/uploadFiles', appCode, bizCode, data, showType) {
  let result = getHeader()
  let headers = result.headers
  data.append('Content-Type', 'multipart/form-data')
  let interfaceCode = result.interfaceCode
  let token = result.token
  let timeStamp = result.timeStamp
  data.append('token', token)
  data.append('timeStamp', timeStamp)
  let config = {
    headers: headers
  }
  return post(url, appCode, bizCode, data, showType, config, true, interfaceCode)
}



// WEBPACK FOOTER //
// ./src/request/handleSend.js